export default "123 328  51 64 \n 45 64  387 23 \n  6 98  215 314\n*   +   *   +  "